import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { MedicalHistoryService } from 'src/app/services/medical-history.service';

@Component({
  selector: 'app-medical-record',
  templateUrl: './medical-record.component.html',
  styleUrls: ['./medical-record.component.css'],
  standalone: false
})
export class MedicalRecordComponent implements OnInit, OnChanges {
  @Input()
  call!: Call;

  @Input()
  index = 0;

  @Input()
  totalCalls = 0;

  medicalHistory?: string;
  isFamilyMemberCall!: boolean;

  constructor(
    private medicalHistoryService: MedicalHistoryService,
  ) { }

  ngOnInit(): void {
    this.getMedicalHistory();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.call) {
      this.getMedicalHistory();
      this.setIsFamilyMemberCall();
    }
  }

  setIsFamilyMemberCall(): void {
    this.isFamilyMemberCall = (this.call.patient?.id || this.call.patient) !== this.call.caller?.id;
  }

  getMedicalHistory(): void {
    this.medicalHistory = this.medicalHistoryService.getMedicalHistory(this.call?.records, this.call?.aiDetectedPathologicalHistory);
  }
}
